var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "sections" }, [
      _c(
        "section",
        [
          _c("h3", [_vm._v("Incognito-Mode")]),
          _vm._v(" "),
          _c("RadioGroup", {
            attrs: { options: _vm.typeOptions },
            on: { change: _vm.typeChanged },
            model: {
              value: _vm.type,
              callback: function($$v) {
                _vm.type = $$v
              },
              expression: "type"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.itemsEligible
        ? _c(
            "section",
            [
              _c("h3", [_vm._v("Ausgeschlossene Personen")]),
              _vm._v(" "),
              _vm._l(_vm.items, function(item, i) {
                return _c("Item", {
                  key: item.id,
                  class: { "mt-2": i > 0 },
                  attrs: {
                    item: item,
                    "is-last": i === _vm.items.length - 1,
                    "is-lone": _vm.items.length === 1
                  },
                  on: {
                    remove: function($event) {
                      return _vm.removeItem(item)
                    },
                    change: function($event) {
                      return _vm.itemChanged(item, $event)
                    },
                    add: _vm.addItem
                  }
                })
              })
            ],
            2
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }